import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderConfirmationComponent } from './order-confirmation/order-confirmation.component';
import { LzExpressOffersComponent } from './lz-express-offers/lz-express-offers.component';
import { GloComponentsModule } from '../shared/components/glo-components.module';
import { SharedComponentsModule } from '../../../shared/components/shared-components.module';

@NgModule({
  declarations: [
    OrderConfirmationComponent,
    LzExpressOffersComponent
  ],
  imports: [
    CommonModule,
    SharedComponentsModule,
    GloComponentsModule
  ],
  exports: [
    OrderConfirmationComponent,
    LzExpressOffersComponent
  ],
  entryComponents: [
    OrderConfirmationComponent,
    LzExpressOffersComponent
  ]
})
export class QuestionnairePostCheckoutModule { }
